// removed by extract-text-webpack-plugin
module.exports = {"header":"Header__header___1z2Bu","content":"Header__content___10Rkp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header.scss
// module id = 91
// module chunks = 0